/*
 * Jira Ticket:
 * Created Date: Mon, 1st Jun 2020, 17:16:27 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Edit, FormTab, TabbedForm, usePermissions, Title } from 'react-admin';
import Detail from './Tabs/Detail';
import Analytics from './Tabs/Analytics';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';

const AdvertEdit = props => {
  const { permissions } = usePermissions();

  return isSuperAdmin(permissions) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <Edit undoable={false} {...props}>
        <TabbedForm redirect={false}>
          <FormTab label="resources.Advert.fields.titles.edit.tab1">
            <Detail {...props} />
          </FormTab>
          <FormTab label="resources.Advert.fields.titles.edit.tab2">
            <Analytics {...props} />
          </FormTab>
        </TabbedForm>
      </Edit>
    </>
  ) : (
    <AccessDenied />
  );
};

export default AdvertEdit;
